import SelectHorsesModal from './SelectHorsesModal';

export default SelectHorsesModal;
